import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import brandHelper from "app/shared/utils/BrandHelper";
import Constants, { Routes } from "app/shared/constants/constants";
import { RootState } from "app/store";
import FeatureFlags from "app/shared/constants/FeatureFlags";
import useFeatureFlags from "../hooks/useFeatureFlags";
import FooterLink from "./FooterLink";
import YourPrivacyChoice from "./YourPrivacyChoice";

const FooterNavbar: React.FC = () => {
    const configs = useSelector((state: RootState) => state.auth.configs);
    const caNoticeOfCollection = configs?.env?.CA_NOTICE_OF_COLLECTION_URL || "#";
    const [isOneTrustCookieEnabled] = useFeatureFlags(FeatureFlags.ONE_TRUST_COOKIE);

    const location = useLocation();
    // Hide Footer in embed mobile giftcard transfer
    if (location.pathname === Routes.MOBILE_GIFTCARD_TRANSFER_ROUTE) {
        return null;
    }

    const EinsteinBrosFooterLinksMap = [
     { label: 'Privacy Policy', url: "https://bagelbrands.com/privacy-policy/" },
     { label: 'CA Notice of Collection', url: caNoticeOfCollection},
     { label: 'Terms of Use', url: "https://bagelbrands.com/terms-of-use/" },
     { label: 'ADA Compliance', url: "https://www.einsteinbros.com/ada-compliance/" },
    ];
        const brueggersFooterLinksMap = [
     { label: 'Privacy Policy', url: "https://bagelbrands.com/privacy-policy/" },
     { label: 'CA Notice of Collection', url: caNoticeOfCollection },
     { label: 'Terms of Use', url: "https://bagelbrands.com/terms-of-use/" },
     { label: 'ADA Compliance', url: "https://www.brueggers.com/ada-compliance/" },
    ];
        const noahsFooterLinksMap = [
     { label: 'Privacy Policy', url: "https://bagelbrands.com/privacy-policy/" },
     { label: 'CA Notice of Collection', url: caNoticeOfCollection },
     { label: 'Terms of Use', url: "https://bagelbrands.com/terms-of-use/" },
     { label: 'ADA Compliance', url: "https://www.noahs.com/ada-compliance/" },
    ];

    return (
        <div>
            {brandHelper()?.brandName === Constants.EINSTEIN_APP && (
                <Container className="web-footer pt-1 pb-1">
                    <Row className="footer-row">
                        <Col lg={4} md={4} sm={12} xs={12} className="footer-col footer-col-copyright">
                            <div>
                                <span>©2025 Einstein Noah Restaurant Group, Inc.</span>
                            </div>
                        </Col>
                        <Col lg={5} md={4} sm={12} xs={12} className="footer-col footer-col-links">
                            <div className="flink d-flex align-items-center" id="oneConsent">
                                {EinsteinBrosFooterLinksMap.map((footerLink) => (
                                    <FooterLink
                                        label={footerLink.label}
                                        url={footerLink.url}
                                        onClick={() => window.open(footerLink.url, "_blank")}
                                        key={footerLink.label}
                                    />
                                ))}
                                {isOneTrustCookieEnabled
                                    && <YourPrivacyChoice />}
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={12} xs={12} className="footer-col footer-col-version">
                            <div>
                                <span className="version">{Constants.APP_VERSION}</span>
                            </div>
                        </Col>
                    </Row>
                </Container>
            )}

            {brandHelper()?.brandName === Constants.NOAH_APP && (
                <Container className="web-footer pt-2 pb-2">
                    <Row className="footer-row">
                        <Col lg={4} md={4} sm={12} xs={12} className="footer-col footer-col-copyright-nohas">
                            <div>
                                <span>®©2025 Einstein Noah Restaurant Group, Inc.</span>
                            </div>
                        </Col>
                        <Col lg={7} md={6} sm={12} xs={12} className="footer-col footer-col-links-nohas">
                            <div className="flink d-flex align-items-center" id="oneConsent">
                                {noahsFooterLinksMap.map((footerLink) => (
                                    <FooterLink
                                        label={footerLink.label}
                                        url={footerLink.url}
                                        onClick={() => window.open(footerLink.url, "_blank")}
                                        key={footerLink.label}
                                    />
                                ))}
                                {isOneTrustCookieEnabled
                                    && <YourPrivacyChoice />}
                            </div>
                        </Col>
                        <Col lg={1} md={2} sm={12} xs={12} className="footer-col footer-col-version">
                            <div>
                                <span className="version">{Constants.APP_VERSION}</span>
                            </div>
                        </Col>
                    </Row>
                </Container>
            )}

            {brandHelper()?.brandName === Constants.BRUEGGERS_APP && (
                <Container className="web-footer pt-2 pb-2">
                    <Row className="footer-row">
                        <Col lg={5} md={5} sm={12} xs={12} className="footer-col footer-col-copyright">
                            <div>
                                <span>©2025 Bruegger’s. All rights reserved.</span>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} xs={12} className="footer-col footer-col-links">
                            <div className="flink d-flex align-items-center" id="oneConsent">
                                {brueggersFooterLinksMap.map((footerLink) => (
                                    <FooterLink
                                        label={footerLink.label}
                                        url={footerLink.url}
                                        onClick={() => window.open(footerLink.url, "_blank")}
                                        key={footerLink.label}
                                    />
                                ))}
                                {isOneTrustCookieEnabled
                                    && <YourPrivacyChoice />}
                            </div>
                        </Col>
                        <Col lg={1} md={1} sm={12} xs={12} className="footer-col footer-col-version">
                            <div>
                                <span className="version">{Constants.APP_VERSION}</span>
                            </div>
                        </Col>
                    </Row>
                </Container>
            )}
        </div>
    );
};

export default FooterNavbar;
